import Vue from 'vue';
import Vuex from 'vuex';
import { getModule, config } from 'vuex-module-decorators';
import CategoriesModule from './Categories';
import ExtNavModule from './ExtNav';
import SectorsModule from './Sectors';
import ExportMarketsModule from './ExportMarkets';
import SettingsModule from './Settings';

Vue.use(Vuex);

// Set rawError to true by default on all @Action decorators
config.rawError = true;

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ExtNavModule,
    SettingsModule,
    SectorsModule,
    CategoriesModule,
    ExportMarketsModule,
  },
});

export const extNavModule = getModule(ExtNavModule, store);
export const settingsModule = getModule(SettingsModule, store);
export const sectorsModule = getModule(SectorsModule, store);
export const categoriesModule = getModule(CategoriesModule, store);
export const exportMarketsModule = getModule(ExportMarketsModule, store);

export default store;
